import { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

export const useSearchQuery = (shopId: string, query: string) => {
  const url: string = `${API_ENDPOINTS.SEARCH_PRODUCTS(shopId, query)}`

  const { data, isError, isLoading } = useApi(query?.length >= 3 ? url : null)
  return {
    results: data?.data,
    isLoading,
    isError,
  }
}
